import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";

// Import routes
import AppRoutes from './routes/AppRoutes';

// Import layout
import { Layout } from './layout';

function App() {
  return (
    <Router>
      <div className="App">
        <Layout>
          <AppRoutes />
        </Layout>
      </div>
    </Router>
  );
}

export default App;
